import React from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { theme } from '../design/theme';

export const UserLayout: React.FC = () => {
  const menuItems = [
    { label: 'My Balance', path: '/user/balance', icon: '💳' },
    { label: 'Usage History', path: '/user/usage', icon: '📜' },
    { label: 'Payment History', path: '/user/payment-history', icon: '💰' },
    { label: 'Support', path: '/user/support', icon: '❓' },
    { label: 'Profile', path: '/user/profile', icon: '👤' },
  ];

  return (
    <div style={{ display: 'flex', minHeight: '100vh', backgroundColor: theme.colors.background.muted }}>
      <Sidebar items={menuItems} title="User Console" />
      <main style={{ 
        flex: 1, 
        paddingLeft: 'var(--sidebar-width, 280px)',
        transition: 'padding-left 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        width: '100%'
      }}>
        <div style={{ 
          maxWidth: theme.layout.maxWidth, 
          margin: '0 auto',
          padding: theme.spacing.xl,
          width: '100%'
        }}>
          <Outlet />
        </div>
      </main>
    </div>
  );
};
